<template>
  <v-container fill-height justify-content-start :class="{'pa-2': $vuetify.breakpoint.xsOnly}" class="app-section-width">
    <v-layout column>
      <v-toolbar color="white" flat>
        <v-btn icon light @click="exit()">
          <v-icon color="grey darken-2">mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title class="grey--text text--darken-4 pa-0">{{getDashboardName({url: $route.path})}}</v-toolbar-title>
      </v-toolbar>
      <v-flex class="app-scroll-section">
        <booking-checkin
          v-for="booking in roomsByBooking"
          :key="booking.booking.id"
          :guestsStatus="guestsStatus"
          :roomsByBooking="booking"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import routeNames from '../router/routes'
import { mapGetters, mapState } from 'vuex'
export default {
  components: {
    BookingCheckin: () => import('@/components/view-components/checkin/BookingCheckin.vue'),
  },
  computed: {
    ...mapState(['me']),
    ...mapGetters({
      getDashboardName: 'service/getDashboardName',
    }),
    guestsStatus () {
      if (this.me.registrationCards !== null && this.me.bookings !== null) {
        return this.me.registrationCards.map((registrationCard) => {
          return {
            id: registrationCard.guestId,
            status: (registrationCard.completedAt !== undefined && registrationCard.completedAt !== null) ||
              (registrationCard.tosSignature && registrationCard.tosSignature.signatureFileId)
              ? 'COMPLETED'
              : 'IN_PROGRESS',
          }
        })
      } else {
        return []
      }
    },
    roomsByBooking () {
      return this.$store.getters['me/roomsByBooking']
    },
  },
  methods: {
    exit () {
      this.$router.push({ name: routeNames.main.name })
    },
  },
  created () {
    this.$store.dispatch('me/getBookings')
    this.$store.dispatch('me/getRegistrationCards')
  },
}
</script>

<style lang="scss">
</style>
